import { LogOut, User } from "lucide-react";
import { useNavigate } from "@tanstack/react-router";
import {
  Avatar,
  AvatarFallback,
  Button,
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
  toast,
} from "@clones/ui";
import { useCurrentRespondent, useLogoutMutation } from "@/auth/queries";

function initials(email: string | null | undefined): string {
  const handle = (email ?? "").split("@")[0] ?? "";
  return (handle.slice(0, 2) || "Р").toUpperCase();
}

export function UserMenu() {
  const { data: account } = useCurrentRespondent();
  const logout = useLogoutMutation();
  const navigate = useNavigate();

  if (!account) return null;

  const handleLogout = async () => {
    try {
      await logout.mutateAsync();
      void navigate({ to: "/login", search: { redirect: undefined } });
    } catch {
      toast.error("Не удалось выйти. Попробуйте ещё раз.");
    }
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" size="icon" aria-label="Меню профиля">
          <Avatar className="h-8 w-8">
            <AvatarFallback>{initials(account.email)}</AvatarFallback>
          </Avatar>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-60">
        <DropdownMenuLabel className="flex flex-col gap-0.5">
          <span className="font-semibold">{account.first_name || "Участник"}</span>
          <span className="text-xs text-muted-foreground">{account.email}</span>
        </DropdownMenuLabel>
        <DropdownMenuSeparator />
        <DropdownMenuItem disabled>
          <User className="mr-2 h-4 w-4" /> Участник интервью
        </DropdownMenuItem>
        <DropdownMenuSeparator />
        <DropdownMenuItem onClick={handleLogout} disabled={logout.isPending}>
          <LogOut className="mr-2 h-4 w-4" /> Выйти
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
